import { PropsWithChildren, useState } from "react";
import CommonLayout from "@components/templates/common-layout";
import CommonHeader from "@components/organisms/common-header";
import CommonFooter from "@components/organisms/common-footer";
import LegalTap from "@components/molecules/legal-tap";
import classNames from "classnames";
interface Props extends PropsWithChildren {
}

export default function LegalLayout(props: Props): JSX.Element {
  return (
    <CommonLayout
      Header={<CommonHeader search hiddeBack autocomplete />}
      Footer={<CommonFooter />}
      className={classNames(
        "w-full !flex !flex-col !items-center !justify-center legal-container pt-16 md:pt-[72px]"
      )}
    >
      <LegalTap />
      {props.children}
    </CommonLayout>
  );
}
